
 <div class="margin">
  <panel heading="{{panelHeading | translate | async}}">
    <div class="system-overview">
      <overview-image size="140" *ngIf="!FamilyImage_Chain && systemName=='Chain' " src="/Content/Images/chain.jpg"  [loading]="loadingSystems"></overview-image>
      <overview-image size="140" *ngIf="FamilyImage_Chain && systemName=='Chain'" [src]="getImage_(FamilyImage_Chain)" [loading]="loadingSystems"></overview-image>

      <overview-image size="140" *ngIf="!FamilyImage_Frame && systemName=='Frame' " src="/Content/Images/frame.jpg"  [loading]="loadingSystems"></overview-image>
      <overview-image size="140" *ngIf="FamilyImage_Frame && systemName=='Frame'" [src]="getImage_(FamilyImage_Frame)" [loading]="loadingSystems"></overview-image>

      <div class="system-overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="'Serial Number' | translate | async" [primary]="true" [loading]="loadingSystems">{{system.SerialNumber}}</item>
            <i  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;" title="Edit Serial Number"   (click)="EditSerial(system)" >
              create
            </i>
          </item-group>
        </div>
        <div class="content__secondary" style="display: flex; flex-direction: row;">
          <item-group>
            <item [label]="'Date Installed' | translate | async" [loading]="loadingSystems">{{system.DateInstalled | date:'dd/MMM/yyyy'}}</item>
            <item [label]="'Equipment SMU/Hourmeter at Install' | translate | async" [loading]="loadingSystems">{{system.SmuAtInstall}}</item>


            
          </item-group>

          <div *ngIf="systemName=='Frame'" style="display: flex; flex-direction: row; justify-content: space-evenly; width: 500px;">

            <div class="column-container__column" >
                <div class="text-block" >
                    <span class="text-block__label"  style=" display: block; margin-bottom: 6px;font-size: 13px;color: #828282; font-weight: 400;">
                        {{ Translate('Frame Configuration') }}
                    </span>
                    <span class="text-block__important" style=" font-size:12px;font-weight: normal;">
                        <ng-container *ngIf="system.ToeOutFrame == 0">
                            Unknown
                        </ng-container>
                        <ng-container *ngIf="system.ToeOutFrame == 1">
                            {{ Translate('Toe Out') }}
                        </ng-container>
                        <ng-container *ngIf="system.ToeOutFrame == 2">
                            {{ Translate('Straight') }}
                        </ng-container>
                        <ng-container>
                            <a  (click)="openTrackCofiguration(1,system.ToeOutFrame,system.Id,system.Side)" >
                                <i class="material-icons " style="color: black; font-size: 16px;">create</i>
                            </a>
                        </ng-container>
                    </span>
                </div>
                
            </div>
            <div class="column-container__column" >
                <div class="text-block" >
                    <span class="text-block__label" style=" display: block; margin-bottom: 6px;font-size: 13px;color: #828282; font-weight: 400;">
                        {{ Translate('Cannon Type') }}
                    </span>
                    <span class="text-block__important"  style=" font-size:12px;font-weight: normal;">
                        <ng-container *ngIf="system.CastFrame == 0">
                            Unknown
                        </ng-container>
                        <ng-container *ngIf="system.CastFrame == 1">
                            {{ Translate('Cast') }}
                        </ng-container>
                        <ng-container *ngIf="system.CastFrame == 2">
                            {{ Translate('Fabricated') }}
                        </ng-container>
                        <ng-container>
                            <a  (click)="openTrackCofiguration(2,system.CastFrame,system.Id,system.Side)" >
                                <i   class="material-icons " style="color: black; font-size: 16px;">create</i>
                            </a>
                        </ng-container>
                    </span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container" [@slideOut] *ngIf="system.Components.length > 0">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th>{{'Pos.' | translate | async}}</th>
            <th>{{'Worn' | translate | async}}</th>
            <th class="right-align" style="text-align-last: center;">{{'Measurement' | translate | async}}</th>
            <th>{{'Tool' | translate | async}}</th>
            <th *ngIf="UTEquivalenetEnabled">{{'UT Equivalent' | translate | async}}</th>
            <th class="right-align">{{'CMU' | translate | async}}</th>
            <th class="right-align">{{'Residual Life' | translate | async}} (100%)</th>
            <th class="right-align">{{'Residual Life' | translate | async}} (120%)</th>
            <th class="inspection-component-photo-header"></th>
            <th class="inspection-component-photo-header"></th>
            <th class="inspection-component-photo-header"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of system.Components">
            <td class="component-cell" *ngIf="!c.IsChild">
              
                <span *ngIf="c.flag_on" style="max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                  <i (click)="onClickFlag(c)" style="color:rgb(88, 170, 5)" class="material-icons sc-icon">flag</i>
              </span>
              
            </td>
           
            <td *ngIf="c.IsChild">
              <span  style="max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
            </span>
            </td>
            <td class="component-cell" *ngIf="!c.IsChild">
              <div class="component-photo-container">
                <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
              </div>
            </td>
            <td *ngIf="c.IsChild" class="line-cell">
              <div class="line-vert{{getChildRowPosition(c.ComponentId)}}"></div>
              <div class="line-hor"></div>
            </td>
           
            <td>
              <span title="{{c.Name}}" *ngIf="!c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}} </span>
              <span title="{{c.Name}}" *ngIf="c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}</span>
            </td>
            <td> {{showPosition(c.Pos, c.ComponentTypeId)}}</td>
           
              <td class="table__eval-cell"><span style="width: 80px;" [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))" >
              <div style=" text-align: center !important ; display: inline-block;"  *ngIf="c.Tool != 'Eval' && c.Measurement!= -1 " > {{c.WornPercentage.toFixed(1)}}%</div>
              <div style=" text-align: center !important ; display: inline-block;"  *ngIf="c.Tool != 'Eval'  && c.Measurement== -1 && c.WornPercentage==0 " >{{'-'}}</div>
              <div style=" text-align: center !important ; display: inline-block;"  *ngIf="c.Tool == 'Eval' ">{{c.EvalCode}}</div>
            </span></td>
            <td class="right-align">
              <div *ngIf="(c.IsChild || !isParent(c.ComponentId)) && c.Tool !== 'Eval' " style="text-align-last: center;">
                
                
                <input  style="width: 100px;" type="number" [(ngModel)]="c.Measurement == -1 ?null : c.Measurement" (change)="updateComponentMeasurement(c.Measurement, c.InspectionDetailId, $event,c)">
                {{unitOfMeasurementShort}}
              </div>
              <div *ngIf="c.Tool === 'Eval'">
                <span [matMenuTriggerFor]="evalMenu" class="tool-button" title="{{'Change Eval' | translate | async}}">{{c.EvalCode }}</span>
                <mat-menu #evalMenu="matMenu">
                  <button mat-menu-item (click)="changeEval('A', c.InspectionDetailId,c.ComponentTypeId)">{{'A' | translate | async}}</button>
                  <button mat-menu-item (click)="changeEval('B', c.InspectionDetailId,c.ComponentTypeId)">{{'B' | translate | async}}</button>
                  <button *ngIf="c.isExcludeC==false" mat-menu-item (click)="changeEval('C', c.InspectionDetailId,c.ComponentTypeId)">{{'C' | translate | async}}</button>
                  <button mat-menu-item (click)="changeEval('X', c.InspectionDetailId,c.ComponentTypeId)">{{'X' | translate | async}}</button>
                </mat-menu>
              </div>
            </td>
            <td>
              <div *ngIf="(c.IsChild || !isParent(c.ComponentId)) && isInspector">.,
                <span [matMenuTriggerFor]="selectToolMenu" class="tool-button" title="{{'Change tool' | translate | async}}">{{c.Tool}}</span>
                <mat-menu #selectToolMenu="matMenu">
                  <button mat-menu-item *ngFor="let tool of c.PossibleTools" (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, tool.ToolId)">{{ tool.ToolName | translate | async}}</button>
                </mat-menu>
              </div>
              <span *ngIf="(c.IsChild || !isParent(c.ComponentId)) && !isInspector">{{c.Tool}}</span>
            </td>
            <td *ngIf="UTEquivalenetEnabled"> 
              <span *ngIf="(c.IsChild || !isParent(c.ComponentId)) && isInspector && c.Tool!='UT' && c.hasUTTool">{{c.UTequvelent}} {{unitOfMeasurementShort}}</span>
            </td>
            <td class="right-align"><span *ngIf="!c.IsChild">{{c.Cmu}} hrs</span></td>
            <td class="right-align"><span *ngIf="!c.IsChild">{{c.RisidualLife100}} hrs</span></td>
            <td class="right-align"><span *ngIf="!c.IsChild">{{c.RisidualLife120}} hrs</span></td>
            <td class="inspection-component-photo">
              <upload-photo *ngIf="c.PhotoThumbnail == '' && isInspector" (onPhotoUpload)="loadPhoto(c)" [inspectionId]="inspectionId" [inspectionDetailId]="c.InspectionDetailId"></upload-photo>

              <i  *ngIf="c.PhotoThumbnail != ''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"  (click)="viewComponentPhoto(c.PhotoId,c.InspectionDetailId,c)" >
                add_a_photo
              </i>
            </td>
            <td class="inspection-component-photo">
               <add-component-comment  (onCommentChange)="loadComment(c)" (updateComment)="updateComment"  [comment]="c.Comment" [inspectionId]="inspectionId" [inspectionDetailId]="c.InspectionDetailId"></add-component-comment>
            
              </td> 
            <td class="inspection-component-photo">
              <div class="add-recommendation" *ngIf="!c.IsChild && isInterpreter" [class.has-recommendation]="componentHasRecommendation(c.ComponentId)">
                <i title="Add Recommendation" class="material-icons" (click)="openAddRecommendation(c.ComponentId)">rate_review</i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
   
    <div *ngIf="removeFlagPopup" class="modal">
      
      <div class="modal__content">
        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <h3>
                    Remove Flag
                </h3>
                <form>
                  <mat-form-field class="header-form-full-width-spinner">
                    <input matInput name="flag_comment" [(ngModel)]="flag_comment" placeholder="Comment"
                      style="margin-left: 15px;" >
                  </mat-form-field>                                    
                </form>
                <div class="button-row text-center">
                    <button mat-raised-button (click)="onClickCloseFlag()">Cancel</button>
                    <button mat-raised-button (click)="onClickRemoveFlag()"  color="primary">Remove Flag</button>
                </div>
            </div>
        </div>
    </div>
  </div>
  </panel>
</div>
